import { Typography } from '@mui/material';

const Text = () => {
  return (
      <Typography
        variant='h4'
        sx={{
          marginTop: '4rem',
          fontSize: '6rem',
          fontFamily: 'Koulen',
          textAlign: 'center'
        }}
      >
        WHAT
      </Typography>
  );
}

export default Text;
